import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';

import { BookingService, LockInfoResponse } from '../booking-api/client';

const LOCK_ID_KEY = 'lock-id';

@Injectable({
  providedIn: 'root'
})
export class LockIdService {
  private readonly lockId: string;

  protected isLoadingLockInfo = false;
  protected lockInfo = new BehaviorSubject<LockInfoResponse | undefined>(undefined);

  constructor(private bookingService: BookingService) {
    this.lockId = localStorage.getItem(LOCK_ID_KEY) ?? sessionStorage.getItem(LOCK_ID_KEY) ?? this.createRandomID();
    localStorage.setItem(LOCK_ID_KEY, this.lockId);
    sessionStorage.setItem(LOCK_ID_KEY, this.lockId);
    void this.loadLockInfo();
  }

  createRandomID(): string {
    try {
      return crypto.randomUUID();
    } catch (e) {
      console.error(e);
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      for (let i = 0; i < 36; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
  }

  getLockId() {
    return this.lockId;
  }

  getLockInfo(): BehaviorSubject<LockInfoResponse | undefined> {
    return this.lockInfo;
  }

  async loadLockInfo() {
    try {
      this.isLoadingLockInfo = false;
      this.lockInfo.next(
        await firstValueFrom(
          this.bookingService.getLockInfo({
            LockInfoRequest: {
              lockId: this.getLockId()
            }
          })
        )
      );
    } catch (e) {
      console.log(e);
      //todo handleError(this.confirmService, e);
    } finally {
      this.isLoadingLockInfo = false;
    }
  }
}
